import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {Spin} from 'antd';

class LoadingAuto extends PureComponent {
    render() {
        const {loading} = this.props;
        if(loading) return (<div className="app-loading"> <Spin tip="Loading..." /> </div>);
        return null;
    }
}


const mapStateToProps = (state) => {
    return {
        loading: state.getIn(['app', 'loading']),
    };
};

export default connect(mapStateToProps, null)(LoadingAuto);
